export const loadFile = (file) =>
  new Promise((res, rej) => {
    const reader = new FileReader();

    reader.onabort = rej;
    reader.onload = () => {
      res({
        name: file.name,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        size: file?.size,
        type: file?.type,
        webkitRelativePath: file?.webkitRelativePath,
        data: reader.result.split(",")[1] ?? "",
      });
    };

    reader.readAsDataURL(file);
  });

export const loadFiles = (files) => {
  const fileArray = Array.isArray(files) ? files : Array.from(files);

  return Promise.all(fileArray.map(loadFile));
};

export const getB64Size = (b64) => (b64.length / 4) * 3;
